/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupsmembershint2Inputs */

const en_groupsmembershint2 = /** @type {(inputs: Groupsmembershint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anyone you remove cannot come back through the link.`)
};

const de_groupsmembershint2 = /** @type {(inputs: Groupsmembershint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wer entfernt wird, kommt auch über den Link nicht mehr rein.`)
};

/**
* | output |
* | --- |
* | "Anyone you remove cannot come back through the link." |
*
* @param {Groupsmembershint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsmembershint2 = /** @type {((inputs?: Groupsmembershint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsmembershint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsmembershint2(inputs)
	return de_groupsmembershint2(inputs)
});
export { groupsmembershint2 as "groupsMembersHint" }